import { Types } from '@grandvisionhq/graphql';
import { enumValueToString } from '@grandvisionhq/utils';

const filterAppointmentTypes = (appointmentTypes, appointmentTypeFilters)=>{
    // only return appointment types that are available for this store
    const filterAvailableStores = ({ isAvailableInStore  })=>isAvailableInStore
    ;
    // Include/exclude appointment types for Try in Store
    const filterTryInStore = (shouldFilter)=>{
        return ({ tryInStore  })=>{
            return shouldFilter ? tryInStore === true : tryInStore === false;
        };
    };
    const tryInStoreFilter = appointmentTypeFilters === null || appointmentTypeFilters === void 0 ? void 0 : appointmentTypeFilters.find((filter)=>'tryInStore' in filter
    );
    const filterGroupId = (groupId)=>{
        return ({ groupId: appointmentTypeGroupId  })=>{
            // If groupId is not provided, return true for all appointment types
            if (!groupId || groupId === null) return true;
            // If groupId is provided, check if it matches the appointment type's groupId
            return appointmentTypeGroupId === groupId;
        };
    };
    const groupIdFilter = appointmentTypeFilters === null || appointmentTypeFilters === void 0 ? void 0 : appointmentTypeFilters.find((filter)=>'groupId' in filter
    );
    var ref;
    return appointmentTypes.filter(filterAvailableStores).filter(filterGroupId((ref = groupIdFilter === null || groupIdFilter === void 0 ? void 0 : groupIdFilter.groupId) !== null && ref !== void 0 ? ref : null)).filter(filterTryInStore(!!(tryInStoreFilter === null || tryInStoreFilter === void 0 ? void 0 : tryInStoreFilter.tryInStore)));
};
const mapAppointmentTypes = (appointmentTypes, appointmentTypeFilters)=>{
    const filteredAppointmentTypes = filterAppointmentTypes(appointmentTypes, appointmentTypeFilters);
    var _amount, _unit;
    return filteredAppointmentTypes.map(({ id , name , description , duration , price , ageGroup , visibleToCustomers  })=>({
            id,
            name,
            description: description !== null && description !== void 0 ? description : '',
            duration: {
                amount: (_amount = duration.amount) !== null && _amount !== void 0 ? _amount : 0,
                unit: (_unit = duration.unit) !== null && _unit !== void 0 ? _unit : 'MINUTES'
            },
            price: price !== null && price !== void 0 ? price : undefined,
            ageGroup: enumValueToString(Types.AppointmentTypeAgeGroup, ageGroup),
            isVisibleToCustomers: visibleToCustomers
        })
    );
};
const fromStoreByIdQueryToStore = (storeQueryData, appointmentTypeFilters)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , globalStoreId , name , shortName , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , slug , appointmentTypes , appointmentsAvailable , servicesNotAvailable ,  } = storeQueryData;
        var ref;
        const isAppointmentsServiceNotAvailable = (ref = servicesNotAvailable === null || servicesNotAvailable === void 0 ? void 0 : servicesNotAvailable.includes(Types.ServicesNotAvailable.APPOINTMENTS)) !== null && ref !== void 0 ? ref : false;
        if (isAppointmentsServiceNotAvailable) {
            console.warn(`Appointment service is not available for store with globalStoreId: ${globalStoreId}.`);
            return null;
        }
        return {
            code,
            globalStoreId,
            name,
            shortName,
            streetName,
            town,
            country,
            phone,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            appointmentTypes: mapAppointmentTypes(appointmentTypes, appointmentTypeFilters),
            appointmentsAvailable,
            servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : []
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

export { fromStoreByIdQueryToStore };
//# sourceMappingURL=from-store-by-id-query-to-store.js.map
